/**
 * 返回上个月结束天数
 * @return {Number}
 */
export function getMonthPreDay(year, month) {
    var date = new Date(year + '/' + month + '/01');
    var day = date.getDay();
    if (day == 0) {
        day = 7;
    }
    return day;
}
/**
 * 补齐数字位数
 * @return {string}
 */
export function getNumTwoBit(n) {
    n = Number(n);
    return (n > 9 ? '' : '0') + n;
}
/**
 * 转成字符串
 * @param year
 * @param month
 * @param day
 * @return {string}
 */
export function parseDate2Str(year, month, day) {
    return year + "-" + getNumTwoBit(month) + "-" + getNumTwoBit(day);
}
/**
 * 日期对象转成字符串
 * @return {string}
 */
export function date2Str(date, split) {
    if (typeof date == 'string')
        return date;
    split = split || '-';
    var y = date.getFullYear();
    var m = getNumTwoBit(date.getMonth() + 1);
    var d = getNumTwoBit(date.getDate());
    return [y, m, d].join(split);
}
/**
 * 返回日期格式字符串
 * @param {Number} 0返回今天的日期、1返回明天的日期，2返回后天得日期，依次类推
 * @return {string} '2014-12-31'
 */
export function getDay(i) {
    i = i || 0;
    var date = new Date();
    var diff = i * (1000 * 60 * 60 * 24);
    date = new Date(date.getTime() + diff);
    return date2Str(date);
}
/**
 * 日期比较
 * @return {Boolean}
 */
export function compareDate(date1, date2) {
    var startTime = new Date(date1.replace('-', '/').replace('-', '/'));
    var endTime = new Date(date2.replace('-', '/').replace('-', '/'));
    if (startTime >= endTime) {
        return false;
    }
    return true;
}
/**
 * 日期时间比较
 * @return {Boolean}
 */
export function compareDateTime(date1, date2) {
    var d1 = new Date(Date.parse(date1));
    var d2 = new Date(Date.parse(date2));
    return d1 > d2;
}
/**
 * 时间是否相等
 * @return {Boolean}
 */
export function isEqual(date1, date2) {
    var startTime = new Date(date1).getTime();
    var endTime = new Date(date2).getTime();
    if (startTime == endTime) {
        return true;
    }
    return false;
}
export function inputDateParseDate(value) {
    var formatType = typeof value;
    var formatDateValue;
    switch (formatType) {
        case 'number':
            formatDateValue = new Date(value);
            break;
        case 'string':
            formatDateValue = new Date(value.replace(/\-/g, '/'));
            break;
        case 'object':
            if (value instanceof Date) {
                return value;
            }
            else {
                return null;
            }
    }
    if (formatDateValue && formatDateValue instanceof Date) {
        return formatDateValue;
    }
    else {
        console.log('请输入正确格式的默认值');
        return null;
    }
}
/**
 * string转成指定类型
 */
export function stringParseInputDateValue(value, valueType) {
    switch (valueType) {
        case 'number':
            return getTimestamp(value);
        case 'object':
            return new Date(value.replace(/\-/g, '/'));
        default:
            return value;
    }
}
/**
 * string转成时间戳
 */
export function getTimestamp(value) {
    if (!value)
        return '';
    var dateTimeParts = value.split(' ');
    var dateParts = (dateTimeParts[0] && dateTimeParts[0].split('-')) || '';
    var timeParts = (dateTimeParts[1] && dateTimeParts[1].split(':')) || '';
    var date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], timeParts[0] || '', timeParts[1] || '', timeParts[2] || '');
    return date.getTime();
}
